import axios from '../../axios'

// 获取批次列表
export const getBatchListByExam = (data) => {
    return axios({
        url: '/api/base/upload/batch',
        method: 'get',
        data
    })
}

// 进度条 id
export const getProgress = (data) => {
    return axios({
        url: '/api/base/upload/progress',
        method: 'get',
        data
    })
}

// 导入导出日志列表
// bizTypeVal 业务类型 1-一分段表导入 2-线下报考学生导入 3-成绩导入 4-考场导入 5. 准考证导出记录 6 -订单导出  7-成绩导出
export const getLogList = (data) => {
    return axios({
        url: '/api/base/upload/record',
        method: 'get',
        data
    })
}

// 查看错误日志 id
export const getLog = (data) => {
    return axios({
        url: '/api/base/upload/log',
        method: 'get',
        data
    })
}

// 支付列表
export const getPayList = (data) => {
    return axios({
        url: '/api/pay/account',
        method: 'get',
        data
    })
}
// 保存支付配置
export const savePayList = (data) => {
    return axios({
        url: '/api/pay/account',
        method: 'post',
        data
    })
}
// 保存支付配置
export const updatePayList = (data) => {
    return axios({
        url: '/api/pay/account',
        method: 'put',
        data
    })
}
// 删除支付
export const deletePayList = (data) => {
    return axios({
        url: '/api/pay/account',
        method: 'delete',
        data
    })
}

// 刷新考试码
export const refreshCode = (data) => {
    return axios({
        url: '/api/mock/base/exam/refresh_code',
        method: 'PUT',
        data
    })
}

// 清除业务缓存
export const clearBusiness = (data) => {
    return axios({
        url: '/api/data/wish/update/business/cache',
        method: 'POST',
        data
    })
}

// 清除用户缓存
export const clearUser = (data) => {
    return axios({
        url: '/api/data/wish/update/user/cache',
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/sys/base.js